const EN_US = {
  'scanAndPayDomain.title': 'Scan And Pay',
  'scanAndPayDomain.refundModal.unitPrice': 'Unit price',
  'scanAndPayDomain.refundModal.qtyInOrder': 'Qty in order',
  'scanAndPayDomain.refundModal.chargedAmount': 'Charged Amount',
  'scanAndPayDomain.refundModal.refund': 'Refund',
  'scanAndPayDomain.refundModal.item': ' item',
  'scanAndPayDomain.refundModal.items': ' items',
  'scanAndPayDomain.refundModal.refundItems': 'Refund items',
  'scanAndPayDomain.refundModal.itemList': 'Item List',
  'scanAndPayDomain.refundModal.prevRefundedItems': 'Previously Refunded Items',
  'scanAndPayDomain.refundModal.orderBreakdown': 'Order Breakdown',
  'scanAndPayDomain.refundModal.originalOrderTotal': 'Original Order Total',
  'scanAndPayDomain.refundModal.refunded': 'Refunded',
  'scanAndPayDomain.refundModal.pendingRefunds': 'Pending Refunds',
  'scanAndPayDomain.refundModal.refundsReturnToPayment':
    'Refunds are returned to the original method of payment.',
  'scanAndPayDomain.refundModal.refundAmount': 'Refund Amount:',
  'scanAndPayDomain.refundModal.completeRefund': 'Complete Refund',
  'scanAndPayDomain.refundModal.itemDescription': 'Item Description',
  'scanAndPayDomain.refundModal.unit': 'Unit USD $',
  'scanAndPayDomain.refundModal.refundReason': 'Refund Reason',
  'scanAndPayDomain.refundModal.refundReason.expired': 'Expired',
  'scanAndPayDomain.refundModal.refundReason.damaged': 'Damaged',
  'scanAndPayDomain.refundModal.refundReason.noReason': 'No Reason',
  'scanAndPayDomain.refundModal.refundReason.default': 'Reason...',
} as const

export default EN_US
